module.exports = __webpack_public_path__ + "img/03.7dc62b3f.png";